<app-simple-grid
  [listOperator]="listReservationsOperator"
  [createOperator]="createReservationOperator"
  [updateOperator]="updateReservationOperator"
  [detailsOperator]="detailsReservationDriverOperator"
  [deleteOperator]="deleteReservationOperator"
  [columnDefs]="columnDefs"
  [baseActions]="baseRowActions()"
  [rowActionSelector]="rowActionSelector"
  (created)="driversChanged.emit()"
  (updated)="driversChanged.emit()"
  (deleted)="driversChanged.emit()" />
